import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { Enum, useAllEnums } from '~/data/enums';

import { TableDataColumn, TableHeaderColumn } from '../TableDataComponents';

import { EmplHistoryDetailType } from './data';
import { EmplDetailHistorySxStyles } from './EmplDetailHistoryStyles';

export type DataType = {
  data: EmplHistoryDetailType[];
};

export const EmplDetailHistory = (props: DataType) => {
  const { data: emplHistoryData } = props;
  const { t } = useTranslation();
  const sxStyles = EmplDetailHistorySxStyles();
  const { allEnums } = useAllEnums();

  const getEnumName = (enumValue: Enum[], id: string) => {
    if (id === undefined || id === '') return '';
    const specificEnum = enumValue.find((en) => en.code === id);
    return !specificEnum ? id : specificEnum.name;
  };

  return (
    <>
      <Table cellSpacing="0" cellPadding="0" sx={sxStyles.tableHeader}>
        <TableHead>
          <TableRow>
            <TableHeaderColumn title={t('laStartDate')} />
            <TableHeaderColumn title={t('laEndDate')} />
            <TableHeaderColumn title={t('laEmploymentStatus')} />
            <TableHeaderColumn title={t('laJobGrade')} />
            <TableHeaderColumn title={t('laTaxNumber')} />
            <TableHeaderColumn title={t('laVacBalCal')} />
            <TableHeaderColumn title={t('fPersonnelGroup1')} />
            <TableHeaderColumn title={t('fPersonnelGroup2')} />
            <TableHeaderColumn title={t('fPersonnelGroup3')} />
            <TableHeaderColumn title={t('fPersonnelGroup4')} />
            <TableHeaderColumn title={t('fPersonnelGroup5')} />
          </TableRow>
        </TableHead>
        <TableBody>
          {emplHistoryData.length > 0 ? (
            emplHistoryData.map((e: EmplHistoryDetailType, index: number) => {
              return (
                <TableRow key={index}>
                  <TableDataColumn
                    title={moment(e.fEmplDetailStartDate).format('DD.MM.YYYY')}
                    first={true}
                  />
                  <TableDataColumn
                    title={moment(e.fEmplDetailEndDate).format('DD.MM.YYYY')}
                  />
                  <TableDataColumn
                    title={getEnumName(
                      allEnums.EMPLOYMENT_STATUS,
                      e.fEmplDetailStatus,
                    )}
                  />
                  <TableDataColumn
                    title={getEnumName(
                      allEnums.JOB_GRADE,
                      e.fEmplDetailJobGrade,
                    )}
                  />
                  <TableDataColumn
                    title={e.fEmplDetailTaxNumber ? e.fEmplDetailTaxNumber : ''}
                  />
                  <TableDataColumn
                    title={
                      e.fEmplDetailVacBalCalcSixDays
                        ? `6 ${t('laDays')}`
                        : `5 ${t('laDays')}`
                    }
                  />
                  <TableDataColumn
                    title={
                      e.fEmplDetailPersonnelGroup1
                        ? getEnumName(
                            allEnums.PERSONNEL_GROUP_1,
                            e.fEmplDetailPersonnelGroup1,
                          )
                        : ''
                    }
                  />
                  <TableDataColumn
                    title={
                      e.fEmplDetailPersonnelGroup2
                        ? getEnumName(
                            allEnums.PERSONNEL_GROUP_2,
                            e.fEmplDetailPersonnelGroup2,
                          )
                        : ''
                    }
                  />
                  <TableDataColumn
                    title={
                      e.fEmplDetailPersonnelGroup3
                        ? getEnumName(
                            allEnums.PERSONNEL_GROUP_3,
                            e.fEmplDetailPersonnelGroup3,
                          )
                        : ''
                    }
                  />
                  <TableDataColumn
                    title={
                      e.fEmplDetailPersonnelGroup4
                        ? getEnumName(
                            allEnums.PERSONNEL_GROUP_4,
                            e.fEmplDetailPersonnelGroup4,
                          )
                        : ''
                    }
                  />
                  <TableDataColumn
                    title={
                      e.fEmplDetailPersonnelGroup5
                        ? getEnumName(
                            allEnums.PERSONNEL_GROUP_5,
                            e.fEmplDetailPersonnelGroup5,
                          )
                        : ''
                    }
                  />
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableDataColumn first={true} title={`${t('laNoHistoryNow')}`} />
            </TableRow>
          )}
        </TableBody>
      </Table>
    </>
  );
};
